import { IntakeQuoteQuery, SvbrgQuoteDraftInput } from '@/generated/gql/graphql';

export enum IntakeQuoteStepLineItemGridField {
  POSITION = 'position',
  TITLE = 'title',
  COMMODITY_GROUP_ID = 'commodityGroupId',
  QUANTITY = 'quantity',
  TOTAL_PRICE_PER_UNIT = 'totalPricePerUnit',
  PRICE_PER_UNIT = 'pricePerUnit',
  DELIVERY_TIME = 'deliveryTime',
  DELETE_ACTION = 'deleteAction',
}

export type IntakeQuote = NonNullable<IntakeQuoteQuery['sevenbridges']['chatSession']['quote']>;

export type IntakeQuoteLineItemGridRow = IntakeQuote['lineItems'][0];

export type IntakeQuoteInput = SvbrgQuoteDraftInput;
